import api from '../config/api';

const authService = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  refresh: () => api.post('/auth/refresh', {}),
  logout: () => api.post('/auth/logout', {}),
  ssoCallback: (ssoToken) => api.post('/auth/sso/nucleus-callback', { ssoToken }),
};

export default authService;
